export const SPECIAL_ID = {
	DISCOUNT: 'discount',
	DISCOUNT_IN_BULK: 'discount_in_bulk'
}
export const SPECIAL_TYPE = {
	DISCOUNT: 'discount'
}
export const MAX_BADGES_ON_CREATION = 3;
